import Vue from 'vue';
import '@/common/user';
// 三方插件
import '@/plugins';
import VueWechatTitle from 'vue-wechat-title';
// 全局组件
import '@/components/global';
// 指令组件
import '@/components/directive';
import App from './App';
import router from '@/router';
import api from '@/api';
import store from '@/stores';
// 样式
import '@/assets/style';
// 过滤器
import '@/common/filter';
// 自定义指令
import '@/common/directive';
Vue.config.productionTip = false;
console.log(window.location.href, '入口url');

Vue.use(VueWechatTitle)

// vconsole调试模式
// import('vconsole/dist/vconsole.min.js').then(module => {
//   const Vconsole = module.default;
//   new Vconsole();
// });

const render = () => {
  new Vue({
    router,
    store,
    render: h => h(App),
    beforeCreate() {
      api.getSoreInfo();
    }
  }).$mount('#app');
};
console.time('manage-order');
setTimeout(() => {
  // 兼容app js代码注入时机 防止同步调用失败
  render();
}, 300);
